module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.deleteModal === true) ? _c('modal', {
    attrs: {
      "title": "Désactiver un cantonnier"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('cantonniers-delete', {
    attrs: {
      "slot": "body",
      "cantonnier": _vm.cantonnier
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updateModal === true) ? _c('modal', {
    attrs: {
      "title": "Modifier un cantonnier"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('cantonniers-form', {
    attrs: {
      "slot": "body",
      "update-cantonnier": _vm.cantonnier
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createModal === true) ? _c('modal', {
    attrs: {
      "title": "Créer un cantonnier"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('cantonniers-form', {
    attrs: {
      "slot": "body"
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-toolbar"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.clickCreate()
      }
    }
  }, [_vm._v("Créer un cantonnier")])]), _vm._v(" "), _c('cantonniers-list', {
    on: {
      "delete": _vm.clickDelete,
      "edit": _vm.clickEdit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-202d7e72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/cantonniers/Cantonniers.vue
// module id = 2091
// module chunks = 2